import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import TransferCreate from './pages/TransferCreate'
import TransferStatus from './pages/TransferStatus'
import TransferHistory from './pages/TransferHistory'
import ApiSettings from './pages/ApiSettings'
import Bindings from './pages/Bindings'
import BindComplete from './pages/BindComplete'
import ToastBar from './components/ToastBar'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import Users from './pages/Users'
import Profile from './pages/Profile'
import Merchants from './pages/Merchants'

function App() {
  return (
    <AuthProvider>
      <Router>
      <ToastBar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
          } />
          <Route path="/transfer/create" element={
            <ProtectedRoute>
              <TransferCreate />
            </ProtectedRoute>
          } />
          <Route path="/transfer/status/:id" element={
            <ProtectedRoute>
              <TransferStatus />
            </ProtectedRoute>
          } />
          <Route path="/transfer/history" element={
            <ProtectedRoute>
              <TransferHistory />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <ApiSettings />
            </ProtectedRoute>
          } />
          <Route path="/bindings" element={
            <ProtectedRoute>
              <Bindings />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/merchants" element={
            <ProtectedRoute>
              <Merchants />
            </ProtectedRoute>
          } />
          <Route path="/bind/complete" element={<BindComplete />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
